import type { MouseEvent, PointerEvent } from 'react';

import { cn } from '@shigo-ui/ui';

export function ScheduleHourButton({
  ariaLabel,
  onClick,
  onPointerDown,
  onPointerEnter,
  selected,
}: {
  ariaLabel: string;
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
  onPointerDown: (event: PointerEvent<HTMLButtonElement>) => void;
  onPointerEnter: () => void;
  selected: boolean;
}) {
  return (
    <button
      type="button"
      aria-label={ariaLabel}
      aria-pressed={selected}
      className={cn(
        'border-border focus-visible:ring-ring h-8 min-w-8 rounded-sm border text-[10px] transition-colors focus-visible:ring-2 focus-visible:outline-none',
        selected
          ? 'bg-primary text-primary-foreground hover:bg-primary/90'
          : 'text-muted-foreground hover:bg-muted bg-transparent',
      )}
      onClick={onClick}
      onPointerDown={onPointerDown}
      onPointerEnter={onPointerEnter}
    />
  );
}
